import { FullScreenProvider } from '@/components/FullScreen';
import { Header } from '@/components/Header';
import { MediaSpendVsContributionGraphSection } from '@/dashboards/SpendSummary/MediaSpendVsContributionGraphSection';
import { MediaSpendVsContributionShareSection } from '@/dashboards/SpendSummary/MediaSpendVsContributionShareSection';
import { SpendSummaryTableSection } from '@/dashboards/SpendSummary/SpendSummaryTableSection';
import { ActionBar } from '@/dashboards/SpendSummary/components/ActionBar';
import { useSpendSummaryUrl } from '@/dashboards/SpendSummary/hooks';
import { SpendSummaryProvider } from '@/dashboards/SpendSummary/providers';
import { useRef } from 'react';

export type FilterNode = {
    name: string;
    type: 'category' | 'variable';
};

const SpentSummaryHeader = () => {
    const { search } = useSpendSummaryUrl();

    return (
        <Header
            className="pb-6 px-8 lg:px-16 pt-6"
            title="Spend summary"
            subtitle={`by ${search.modelBreakdown}`}
            tooltip="Take a deep dive into media efficiency. Consider how spending in each channel translates into actual results. Identify the strongest contributors and the underperformers by ROI to ensure you are getting the best value for money."
            sticky
        >
            <ActionBar />
        </Header>
    );
};

export const SpendSummary = () => {
    const portalRef = useRef<HTMLDivElement>(null);

    return (
        <SpendSummaryProvider>
            <SpentSummaryHeader />
            <div className="pb-8 px-8 lg:px-16">
                <div className="transition-all duration-300" ref={portalRef} />

                <FullScreenProvider portalRef={portalRef}>
                    <div className="flex flex-row flex-wrap gap-4 w-full h-full justify-stretch">
                        <div className="flex flex-col gap-4 flex-1 w-1/2 max-sm:w-full">
                            <SpendSummaryTableSection />
                            <MediaSpendVsContributionShareSection />
                        </div>
                        <div className="h-full flex-1 w-1/2 max-sm:w-full">
                            <MediaSpendVsContributionGraphSection />
                        </div>
                    </div>
                </FullScreenProvider>
            </div>
        </SpendSummaryProvider>
    );
};
